// extracted by mini-css-extract-plugin
export default {"menu":"HeaderDropdownMenu_menu__ASBch","menuItem":"HeaderDropdownMenu_menuItem__t-eiC","menuIcon":"HeaderDropdownMenu_menuIcon__0X3AJ"};